import { Component, HostBinding, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { GridCell } from '../../models/sections-model';

@Component({
  selector: 'kw-grid-cell-wrapper',
  templateUrl: './grid-cell-wrapper.component.html',
  styleUrls: ['./grid-cell-wrapper.component.scss']
})
export class GridCellWrapperComponent implements OnInit, OnChanges {
  @Input() gridCell: GridCell;
  @HostBinding("style.--cell-background-color") bgColor: string;
  @HostBinding("style.--cell-border-width") borderWidth: string;
  @HostBinding("style.--cell-border-color") borderColor: string;
  @HostBinding("style.--cell-border-style") borderStyle: string;
  @HostBinding("style.border-radius") borderRadius: string;
  @HostBinding("style.border") cellBorder: string;

  constructor() { }


  ngOnInit(): void {
    console.log(this.gridCell)
    if (this.gridCell != undefined) {
      if (this.gridCell?.bgColor != undefined) {
        this.bgColor = this.gridCell.bgColor
      }
      if (this.gridCell?.borderColor != undefined) {
        this.borderColor = this.gridCell.borderColor
      }
      if (this.gridCell?.borderWidth != undefined) {
        this.borderWidth = this.gridCell.borderWidth
      }
      if (this.gridCell?.borderStyle != undefined) {
        this.borderStyle = this.gridCell.borderStyle
      }
      if (this.gridCell?.borderRadius != undefined) {
        this.borderRadius = this.gridCell.borderRadius
      }
      if (this.gridCell?.border != undefined) {
        console.log(this.gridCell.border)
        this.cellBorder = this.gridCell.border
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["gridCell"]) {
      console.log(this.gridCell)
      if (this.gridCell?.border != undefined) {
        this.cellBorder = this.gridCell.border
      }
    }
  }

}
